import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'
import { Provider } from 'react-redux'
import { store } from '@/app/store'
import { i18next } from './i18next'
import { BrowserRouter } from 'react-router-dom'
import { setupCacheAutoClearOnReload } from '@/shared/api/request'

i18next.then(() => {
	if (process.env.NODE_ENV === 'development') {
	}
})

setupCacheAutoClearOnReload()

ReactDOM.render(
	<StrictMode>
		<BrowserRouter>
			<Provider store={store}>
				<App />
			</Provider>
		</BrowserRouter>
	</StrictMode>,
	document.getElementById('root')
)
